<div class="flex w-full">
	<div class="w-1/2 mr-2">
		<h3>HST on sale price</h3>
		<div class="flex flex-col justify-between mt-4">
			<span>Based on net sale price</span>
			<span class="font-bold">
				{{ salePriceAdjustmentCalculated.absAmount | centsToDollars }}</span
			>
		</div>

		<div class="my-4">
			<app-checkbox
				(ngModelChange)="toggleSingleAdjustments($event)"
				[ngModel]="
					salePriceAdjustment?.hstSalePrice?.fedAndProvAsSingleAdjustments
				"
				type="clear"
				>Show Fed. & Prov. portions as separate adjustments</app-checkbox
			>
		</div>

		<div class="my-4">
			<app-checkbox
				(ngModelChange)="toggleDetails($event)"
				[ngModel]="salePriceAdjustment?.hstSalePrice?.details"
				type="clear"
				>Include all details in document</app-checkbox
			>
		</div>

		<div class="flex justify-between mt-4">
			<app-button size="small" btn="secondary" mat-dialog-close
				>Cancel</app-button
			>
			<app-button size="small" (click)="save()">Save</app-button>
		</div>
	</div>

	<div class="w-1/2">
		<app-container type="dark" title="Details">
			<div class="flex justify-between mt-2">
				<span> HST Federal portion (5%) </span>

				<span>
					{{ salePriceHSTCalculated.hstFed | centsToDollars }}
				</span>
			</div>
			<div class="flex justify-between mt-2">
				<span> HST Ontario portion (8%) </span>

				<span>
					{{ salePriceHSTCalculated.hstProv | centsToDollars }}
				</span>
			</div>
			<div class="mt-2 flex justify-end font-bold">
				<span
					>Credit Vendor =
					{{ salePriceHSTCalculated.absAmount | centsToDollars }}</span
				>
			</div>
		</app-container>
	</div>
</div>
